<template>
  <div class="app df aic jcc" >
    <router-view></router-view>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.app{
  min-height: 100%;
  width: 100%;
  padding: 24px 0;
  background:
    radial-gradient(circle at 15% 0%, rgba(212, 231, 221, .72), transparent 35%),
    #f4f6f3;
}

@media (max-width: 599px) {
  .app { padding: 0; background: #fff; }
}


</style>
